var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFabricIconNoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2919 9.20593L20 7.16888L19.2844 5.11002L19.988 2.50732H9.81673C9.84971 2.7182 9.86688 2.93411 9.86688 3.15399V17.0274H9.86565C9.83974 18.1683 9.35404 19.198 8.586 19.9402H19.9919L19.2849 17.3749L20 15.3174L19.2919 13.2802L20 11.243L19.2919 9.20593Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08397 12.7351H5.64926C6.86542 12.7351 7.96273 13.2501 8.73323 14.0723V3.06854C8.73323 1.3765 7.34974 0 5.64926 0H3.08397C1.38348 0 0 1.3765 0 3.06854V14.0723C0.770493 13.2501 1.8678 12.7351 3.08397 12.7351Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73323 16.9317C8.73323 15.2398 7.34974 13.8633 5.64926 13.8633H3.08397C1.38348 13.8633 0 15.2398 0 16.9317C0 18.6237 1.38348 20.0002 3.08397 20.0002H5.64926C7.34974 20.0002 8.73323 18.6237 8.73323 16.9317ZM2.3604 16.9318C2.3604 16.5348 2.68492 16.2118 3.08397 16.2118H5.64911C6.04831 16.2118 6.37282 16.5348 6.37282 16.9318C6.37282 17.3289 6.04816 17.6517 5.64911 17.6517H3.08397C2.68492 17.6517 2.3604 17.3289 2.3604 16.9318Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabricIconNoColor);
export default __webpack_public_path__ + "static/media/fabricIconNoColor.ee18bc47.svg";
export { ForwardRef as ReactComponent };